import { GatsbyImage } from "gatsby-plugin-image";
import styled, { device, themeGet } from "../styled";

export const BackgroundWrap = styled.div`
    display: grid;
`;

export const SectionWrap = styled.div`
    grid-area: 1/1;
    width: 100%;
    min-height: 570px;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (max-width: 850px) {
        padding: 20px 0;
    }
`;

export const SectionTitle = styled.div`
    color: #fff;
    text-align: center;
    padding: 20px;
    text-shadow:
        0px 0px 20px rgb(0 0 0),
        0px 0px 20px rgb(0 0 0);
`;

export const CardsWrap = styled.div`
    width: 90%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    @media (max-width: 850px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`;

export const BackgroundImage = styled(GatsbyImage)`
    grid-area: 1/1;
    z-index: -1;
    // TODO https://github.com/timhagn/gatsby-background-image/issues/179
    @media (min-width: 1500px) {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        padding: 0;
    }
`;
